import { useState, useEffect } from "react";
import { getTemplates, createTemplate, updateTemplate, deleteTemplate } from "../../mailerApi";
import RichTextEditor from "../../components/RichTextEditor";
import "./Mailer.css";

function stripHtml(html) {
  if (!html) return "";
  return html
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<\/p>/gi, " ")
    .replace(/<\/div>/gi, " ")
    .replace(/<\/li>/gi, " ")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/\s+/g, " ")
    .trim();
}

export default function TemplatesPage() {
  const [templates, setTemplates] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ subject: "", body: "" });
  const [error, setError] = useState("");

  async function load() {
    try {
      const data = await getTemplates();
      setTemplates(Array.isArray(data) ? data : data.results || []);
    } catch (e) { setError(e.message); }
  }

  useEffect(() => { load(); }, []);

  function openCreate() {
    setEditing(null);
    setForm({ subject: "", body: "" });
    setShowForm(true);
  }

  function openEdit(t) {
    setEditing(t);
    setForm({ subject: t.subject, body: t.body });
    setShowForm(true);
  }

  async function handleSave() {
    try {
      if (editing) {
        await updateTemplate(editing.id, form);
      } else {
        await createTemplate(form);
      }
      setShowForm(false);
      load();
    } catch (e) { setError(e.message); }
  }

  async function handleDelete(id) {
    if (!window.confirm("წავშალოთ ეს შაბლონი?")) return;
    await deleteTemplate(id);
    load();
  }

  return (
    <div className="mailer-page">
      <div className="mailer-header">
        <h1>შაბლონები</h1>
        <button className="btn btn-primary" onClick={openCreate}>+ ახალი შაბლონი</button>
      </div>

      {error && <div className="mailer-error">{error}<button onClick={() => setError("")}>×</button></div>}

      <div className="templates-grid">
        {templates.length === 0 ? (
          <div className="no-data-card">შაბლონები არ მოიძებნა</div>
        ) : templates.map(t => (
          <div key={t.id} className="template-card">
            <div className="template-card-header">
              <h3>{t.subject}</h3>
              <div className="template-card-actions">
                <button className="btn-icon" onClick={() => openEdit(t)} title="რედაქტირება">✏️</button>
                <button className="btn-icon" onClick={() => handleDelete(t.id)} title="წაშლა">🗑</button>
              </div>
            </div>
            {(() => {
              const preview = stripHtml(t.body);
              return (
                <p className="template-body-preview">
                  {preview.substring(0, 150)}{preview.length > 150 ? "..." : ""}
                </p>
              );
            })()}
            <div className="template-card-footer">
              <span>{new Date(t.updated_at).toLocaleDateString("ka-GE")}</span>
            </div>
          </div>
        ))}
      </div>

      {showForm && (
        <div className="modal-overlay" onClick={() => setShowForm(false)}>
          <div className="modal-content modal-wide" onClick={e => e.stopPropagation()}>
            <h2>{editing ? "შაბლონის რედაქტირება" : "ახალი შაბლონი"}</h2>
            <div className="form-group">
              <label>სათაური</label>
              <input value={form.subject} onChange={e => setForm({...form, subject: e.target.value})} />
            </div>
            <div className="form-group">
              <label>ტექსტი</label>
              <RichTextEditor
                value={form.body}
                onChange={(html) => setForm(prev => ({ ...prev, body: html }))}
                placeholder="შაბლონის ტექსტი..."
                minRows={10}
              />
            </div>
            <div className="personalization-bar">
              <span className="personalization-label">პერსონალიზაცია:</span>
              <button type="button" className="placeholder-btn" onClick={() => setForm(f => ({...f, body: f.body + "{name}"}))}>
                {"{name}"} — სახელი
              </button>
              <button type="button" className="placeholder-btn" onClick={() => setForm(f => ({...f, body: f.body + "{email}"}))}>
                {"{email}"} — მეილი
              </button>
            </div>
            <div className="modal-actions">
              <button className="btn btn-secondary" onClick={() => setShowForm(false)}>გაუქმება</button>
              <button className="btn btn-primary" onClick={handleSave}>შენახვა</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
